/* src/app/components/companies-components/companies-company-info-card/companies-company-info-card.component.scss */
.info-card footer > p {
  margin: 3rem 0 0 0;
  opacity: 0.75;
}
.info-card footer > div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.info-card footer > div:last-of-type {
  justify-content: flex-end;
}
.info-card footer > h6 {
  align-self: center;
}
/*# sourceMappingURL=companies-company-info-card.component.css.map */
